import ApiResponse from "../models/ApiResponse";
import { TestCaseSearchResult } from "../models/test-series/TestCaseSearchResult";
import TestSeriesDTO from "../models/TestSeriesDTO";
import Api from "./Api";

class ReusedTestSeriesApi {
  constructor(private api: Api) {}

  public addReusedTestSeries(requestId: string, payload: number[]): ApiResponse<void> {
    return this.api.patch(`/test-request/v2/testrequests/${requestId}/reused-test-series`, payload);
  }

  public fetchReusedTestSeries(requestId: string, reusedTestSeriesId: number): ApiResponse<TestSeriesDTO> {
    return this.api.get(`/test-request/v2/testrequests/${requestId}/reused-test-series/${reusedTestSeriesId}`);
  }

  public fetchReusedTestSeriesTestCases(
    requestId: string,
    reusedTestSeriesId: number,
  ): ApiResponse<TestCaseSearchResult[]> {
    return this.api.get(
      `/test-request/v2/testrequests/${requestId}/reused-test-series/${reusedTestSeriesId}/test-cases`,
    );
  }

  public removeReusedTestSeries(requestId: string, reusedTestSeriesId: number): ApiResponse<void> {
    return this.api.delete(`/test-request/v2/testrequests/${requestId}/reused-test-series/${reusedTestSeriesId}`);
  }
}

export default ReusedTestSeriesApi;
